<template>
  <v-card class="category-card" flat>
    <v-card-title class="category-title">
      <slot />
    </v-card-title>
  </v-card>
</template>

<style scoped>
.category-card {
  background: white;
  border-radius: 8px;
  width: 100%;
}

.category-title {
  font-size: var(--title-font-size, 24px);
  font-weight: bold;
  padding: 20px 24px 10px;
  color: #333;
  text-align: center;
}
</style>
